import React from 'react';
import PropTypes from 'prop-types';

const UserIcon = () => (
  <svg width="13" height="13" viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <circle cx="8" cy="5" r="3" stroke="rgb(39,67,178)" strokeWidth="1.5" />
    <path d="M2 15c0-3.3 2.7-6 6-6s6 2.7 6 6" stroke="rgb(39,67,178)" strokeWidth="1.5" />
  </svg>
);

const CheckIcon = () => (
  <svg width="10" height="10" viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <polyline points="3,8 6.5,12 13,5" stroke="rgb(39,67,178)" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

const OnboardingPlanCard = ({ plan, onSelect, isLoading, isSelected }) => {
  const buttonClass =
    plan.buttonVariant === 'outline'
      ? 'onboarding-plan-card__button onboarding-plan-card__button--outline'
      : 'onboarding-plan-card__button onboarding-plan-card__button--primary';

  return (
    <article
      className={`onboarding-plan-card ${plan.recommended ? 'onboarding-plan-card--recommended' : ''} ${
        isSelected ? 'onboarding-plan-card--selected' : ''
      }`}
    >
      {plan.recommended && <span className="onboarding-plan-card__badge">Recomendado</span>}

      <div className="onboarding-plan-card__header">
        <h3 className="onboarding-plan-card__name">{plan.name}</h3>
        <p className="onboarding-plan-card__subtitle">{plan.subtitle}</p>
      </div>

      <div className="onboarding-plan-card__users">
        <span className="onboarding-plan-card__users-icon">
          <UserIcon />
        </span>
        <span>{plan.users}</span>
      </div>

      <div className="onboarding-plan-card__price-block">
        <div className="onboarding-plan-card__price-row">
          <span className="onboarding-plan-card__price">{plan.priceLabel}</span>
          <span className="onboarding-plan-card__period">/ mes*</span>
        </div>
        <p className="onboarding-plan-card__billing-note">*Valor neto + IVA. Tu primer mes cuesta $1.000 + IVA.</p>
      </div>

      <button type="button" className={buttonClass} disabled={isLoading} onClick={() => onSelect(plan)}>
        {isLoading && isSelected ? 'Guardando...' : plan.buttonLabel}
      </button>

      <div className="onboarding-plan-card__divider" />

      <div className="onboarding-plan-card__features">
        <p className="onboarding-plan-card__features-title">{plan.featuresTitle || 'Este plan incluye:'}</p>
        <ul className="onboarding-plan-card__features-list">
          {plan.features.map(feature => (
            <li key={feature}>
              <span className="onboarding-plan-card__check">
                <CheckIcon />
              </span>
              <span>{feature}</span>
            </li>
          ))}
        </ul>
      </div>
    </article>
  );
};

OnboardingPlanCard.propTypes = {
  plan: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    users: PropTypes.string.isRequired,
    priceLabel: PropTypes.string.isRequired,
    buttonLabel: PropTypes.string.isRequired,
    buttonVariant: PropTypes.string,
    recommended: PropTypes.bool,
    features: PropTypes.arrayOf(PropTypes.string).isRequired
  }).isRequired,
  onSelect: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  isSelected: PropTypes.bool
};

OnboardingPlanCard.defaultProps = {
  isLoading: false,
  isSelected: false
};

export default OnboardingPlanCard;
